module.exports = __webpack_public_path__ + "img/1.29b2f09f.jpg";